
import { useMemo } from 'react';
import { useScheduleDataFetcher } from './dynamic-slots/useScheduleDataFetcher';
import { useSlotsGenerator } from './dynamic-slots/useSlotsGenerator';

// Re-export types for backward compatibility
export type { TimeSlot, PsychologistSchedule } from './dynamic-slots/types';

export const useDynamicSlots = () => {
  const {
    scheduleBlocks,
    bookedSlots,
    pricing,
    isLoading,
    loadPsychologistSchedule
  } = useScheduleDataFetcher();

  const {
    generateSlots,
    getAllSlotsForDuration,
    getGroupedSlots
  } = useSlotsGenerator(scheduleBlocks, bookedSlots, pricing);

  const memoizedValues = useMemo(() => ({
    scheduleBlocks,
    bookedSlots,
    pricing,
    isLoading,
    loadPsychologistSchedule,
    getAllSlotsForDuration,
    getGroupedSlots
  }), [
    scheduleBlocks,
    bookedSlots,
    pricing,
    isLoading,
    loadPsychologistSchedule,
    getAllSlotsForDuration,
    getGroupedSlots
  ]);

  return memoizedValues;
};
